import * as React from 'react';
export const eslSvg = React.forwardRef(function eslSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#2683B2',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4 16.593c0-.13.048-.266.065-.395a7.762 7.762 0 0 1 1.726-3.873A10.917 10.917 0 0 1 9.737 9.33a13.918 13.918 0 0 1 4.034-1.186c.452-.064.912-.097 1.363-.145h1.736c.113 0 .226.04.347.048a14.36 14.36 0 0 1 3.816.807 12.045 12.045 0 0 1 4.325 2.582 8.39 8.39 0 0 1 2.42 3.792c.193.707.261 1.441.202 2.17v-.25c0-.08 0-.169-.04-.258a7.568 7.568 0 0 0-1.509-3.453 10.562 10.562 0 0 0-3.639-3.026 13.966 13.966 0 0 0-4.486-1.436c-.948-.14-1.907-.19-2.864-.153A14.055 14.055 0 0 0 8.35 10.96a9.763 9.763 0 0 0-3.227 3.227 7.593 7.593 0 0 0-1.057 3.228.404.404 0 0 1 0 .105L4 16.593Z',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.131 12.494h5.341v1.372a9.206 9.206 0 0 0-1.815-.162H9.834v2.768h2.146c.195-.014.39-.044.58-.089v1.38a20.407 20.407 0 0 0-2.726-.097v2.961h2.468a1.977 1.977 0 0 0 1.275-.516v1.71H8.091c.107-3.109.12-6.218.04-9.327Zm10.997.065v1.694l-.088-.08a2.422 2.422 0 0 0-2.106-.662 1.145 1.145 0 0 0-.88.532 1.033 1.033 0 0 0 .283 1.364c.329.24.683.443 1.057.605.506.21.986.482 1.428.807a2.566 2.566 0 0 1 .968 2.05 2.84 2.84 0 0 1-.71 2.049 3.073 3.073 0 0 1-1.694.927c-.893.2-1.826.13-2.68-.201-.185-.073-.346-.178-.515-.258v-1.937c.177.186.338.38.524.557.515.512 1.21.802 1.936.807a1.613 1.613 0 0 0 1.235-.468 1.3 1.3 0 0 0-.121-1.896 6.049 6.049 0 0 0-1.21-.75 23.83 23.83 0 0 1-1.219-.71 2.017 2.017 0 0 1-.952-1.348 2.542 2.542 0 0 1 .581-2.162 3.228 3.228 0 0 1 2.058-1.122 3.503 3.503 0 0 1 1.823.113l.282.089Zm1.227-.065h1.759c-.137 2.703 0 5.406-.081 8.069h.056c.694 0 1.388 0 2.074-.049.216-.017.43-.057.637-.12.27-.074.505-.236.67-.46v1.815h-5.115c.064-3.05.088-6.148 0-9.255Z',
      fill: '#fff',
    }),
  );
});
eslSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var esl = {
  category: 'brand',
  colorable: false,
  name: 'esl',
  svg: eslSvg,
};
